import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Initialize Sentry
if (environment['SENTRY_DSN']) {
  Sentry.init({
    dsn: environment['SENTRY_DSN'],
    environment: environment['SENTRY_ENVIRONMENT'] || 'unknown',
    release: environment['SENTRY_RELEASE'] || 'master',
    beforeSend(event) {
      // Set module tag
      if (event.tags) {
        event.tags.module = 'frontend-angular-admin';
      } else {
        event.tags = { module: 'frontend-angular-admin' };
      }

      // Filter out browser extension errors
      if (event.exception && event.exception.values) {
        const exceptionValue = event.exception.values[0];
        const message = exceptionValue && exceptionValue.value ? exceptionValue.value : '';

        if (message.indexOf('chrome-extension://') !== -1 ||
            message.indexOf('moz-extension://') !== -1 ||
            message.indexOf('ResizeObserver') !== -1) {
          return null;
        }
      }
      return event;
    }
  });
}

if (environment.production) {
  enableProdMode();
}

if (window.location.href.indexOf(environment.SIGNIFY_TRIGGER) !== -1) {
  environment.API_ENDPOINT = environment.API_ENDPOINT_SIGNIFY;
  environment.BASE_URL = environment.BASE_URL_SIGNIFY;
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));



// WEBPACK FOOTER //
// ./src/main.ts